import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { provideOAuthClient, OAuthStorage } from 'angular-oauth2-oidc';
import Aura from '@primeuix/themes/aura';
import { authInterceptor } from 'shared-services';
import { routes } from './app.routes';

export function storageFactory(): OAuthStorage {
  return typeof localStorage !== 'undefined' ? localStorage : {
    getItem: () => null,
    removeItem: () => {},
    setItem: () => {}
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideOAuthClient(),
    { provide: OAuthStorage, useFactory: storageFactory },
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities'
          }
        }
      }
    })
  ]
};
